import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { AnalysisRcaFilterModel } from '../../../../../filters/analysis-rca-filter.modal'
import { Subscription } from 'rxjs'
import { PaginationModel } from '../../../../../models/pagination.model'
import { HttpResponseHandlerService } from '../../../../../services/http-response-handler.service'
import { ActivatedRoute, Event, NavigationEnd, Params, Router } from '@angular/router'
import { IFinalElementAnalyzerResource } from '../../../../../resources/final-element-analyzer.resource'
import { HttpErrorResponse } from '@angular/common/http'
import { HelperService } from '../../../../../services/helper.service'
import IAnalysisService from '../i-analysis.service'

@Component({
    selector: 'app-analysis-view-document-items',
    templateUrl: './analysis-view-document-items.component.html',
    standalone: false
})
export class AnalysisViewDocumentItemsComponent implements OnInit, OnDestroy {
  @Input() type: 'F' | 'D' | 'O'
  @Input() serviceInstance: IAnalysisService
  @Input() activeRCA: boolean = false
  @Input() backRef: string
  @Input() disableReactivateRCA: boolean = false
  @Output() refreshPageEvent: EventEmitter<boolean> = new EventEmitter<boolean>()

  public filter: AnalysisRcaFilterModel
  public maxBodyTableHeight: string = '400px'

  private destroy$: Subscription = new Subscription()
  private _pagination: PaginationModel = new PaginationModel()
  private _collectionSize: number = 0
  private _isLoading: boolean = false
  private _reportItems: any[] = []

  public get page(): number {
    return this._pagination.no
  }

  public get pageSize(): number {
    return this._pagination.size
  }

  public get collectionSize(): number {
    return this._collectionSize
  }

  public get isLoading(): boolean {
    return this._isLoading
  }

  public get reportItems(): any[] {
    return this._reportItems
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private responseHandlerService: HttpResponseHandlerService,
  ) {}

  private getReportData(): void {
    this._isLoading = true
    this._reportItems = []
    this.serviceInstance.getRCAReportData(this._pagination, this.filter, this.activeRCA).subscribe({
      next: (resource: IFinalElementAnalyzerResource) => {
        this._reportItems = resource.data.items
        this._collectionSize = resource.data.count
        this._isLoading = false
      },
      error: (err: HttpErrorResponse): void => {
        this.responseHandlerService.notifyError(err)
        this._isLoading = false
      },
    })
  }

  public getRCALabel(): string {
    if (this.type === 'F') {
      return 'RCA Fault No'
    }
    if (this.type === 'D') {
      return 'RCA Demand No'
    }
    if (this.type === 'O') {
      return 'RCA Override No'
    }
    return 'RCA No'
  }

  public onPageChanged(event): void {
    this._pagination.no = event
    HelperService.scrollToTopNzTable()
    this.getReportData()
  }

  public onPageSizeChanged(event: number): void {
    this._pagination.no = 1
    this._pagination.size = event
    this.getReportData()
  }

  public onOpenRCA(item: any): void {
    this._isLoading = true
    this.serviceInstance.openTag(item.tag, item.no).subscribe({
      next: (response: any) => {
        this._isLoading = false
        this.responseHandlerService.notifySuccess('Success!', 'Tag reactivated with success!')
        this.refreshPageEvent.emit(true)
      },
      error: (error: HttpErrorResponse) => {
        this._isLoading = false
        this.responseHandlerService.notifyError(error)
      },
    })
  }

  public getBackRefParam(): any {
    if (this.backRef) {
      return { ref: this.backRef }
    }
    return {}
  }

  private parseQueryParams(params: any): void {
    if (!HelperService.isNullOrUndefined(params)) {
      if (params.filter) {
        this.filter = JSON.parse(params.filter)
        this.filter = AnalysisRcaFilterModel.fromJson(this.filter)
      } else {
        this.filter = undefined
      }
    }
  }

  private setTableBodyHeight(): void {
    let heightToReduce: number = 350
    if (this.filter && JSON.stringify(this.filter.toJson()) !== '{}') {
      heightToReduce += 35
    }
    this.maxBodyTableHeight = `${HelperService.getBodyTableHeight(heightToReduce, 400)}px`
  }

  private rebuildPage(): void {
    this._pagination.no = 1
    const queryParams: Params = this.activatedRoute.snapshot.queryParams
    this.parseQueryParams(queryParams)
    this.getReportData()
    this.setTableBodyHeight()
  }

  ngOnInit(): void {
    this.rebuildPage()
    // Detect Page Change
    this.destroy$ = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.rebuildPage()
      }
    })
  }

  public ngOnDestroy(): void {
    this.destroy$.unsubscribe()
  }
}
